import React from "react";
import { Card, Table, Typography } from 'antd';
import 'dayjs/locale/uk';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat'
import { useGetUserDetailsQuery } from '../../services/auth/authService'
const { Text } = Typography;

const BillSubComponent = () => {
    const { data: userInfo = {}, isFetching: isUserInfoFetching } = useGetUserDetailsQuery()
    dayjs.extend(LocalizedFormat);
    const columns = [
        {
            title: 'Назва',
            dataIndex: 'description',
            width: '20%',
            key: 'description',
        },
        {
            title: 'Дата',
            dataIndex: 'date',
            width: '30%',
            key: 'date',
            render: (date) => dayjs(date).locale('uk').format('LLLL')
        },
        {
            title: 'Сума',
            dataIndex: 'price',
            key: 'price',
            width: '20%',
        },
        {
            title: 'Оплачено',
            dataIndex: 'paid',
            key: 'paid',
            width: '21%',
            render: (paid) => paid ? 'Так' : 'Ні'
        },
    ];
    return (
        <Card className="compact-section-card" bordered={false}>
            <div className="compact-section-head">
                <Text className="compact-section-title">Рахунки</Text>
                <Text className="compact-section-subtitle">
                    {userInfo.bills?.filter((bill) => !bill.paid).length || 0} неоплачених
                </Text>
            </div>
                <Table
                    className="compact-table"
                    bordered
                    scroll={{
                        x: 560,
                        y: 500,
                    }}
                    columns={columns}
                    rowKey={(record) => record.id}
                    pagination={false}
                    dataSource={userInfo.bills}
                    rowClassName={(record) => !record.paid ? 'amount-negative' : 'amount-positive'}
                    size="small"
                    loading={isUserInfoFetching}
                />
        </Card>
    )
}

export default BillSubComponent
